module.exports = __webpack_public_path__ + "appium.165dx2hv.svg";